<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import RejectionConfirmationModal from "@/components/approval-center/modals/RejectionConfirmationModal.vue";
import {ref, watch} from "vue";

defineProps({
  approval: {
    type: Object,
    required: true,
  },
  category: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['modalChanged']);

const showConfirmationModal = ref(false);

const toggleConfirmationModal = () => {
  showConfirmationModal.value = !showConfirmationModal.value;
}

watch(
  showConfirmationModal,
  () => emit('modalChanged', showConfirmationModal.value),
  {
    immediate: true,
  },
)
</script>

<template>
  <DefaultButton
    v-if="approval.can_be_rejected"
    variant="danger"
    class="border-0 !tw-px-2 !tw-py-0 hover:!tw-bg-transparent"
    @click="toggleConfirmationModal"
  >
    <svg-vue
      icon="icons/trash"
      class="tw-w-4 tw-h-4 tw-mr-2"
    />
    <span>Reject Suggestion</span>
  </DefaultButton>

  <RejectionConfirmationModal
    v-if="showConfirmationModal"
    :approval-id="approval.id"
    :category="category"
    @close="toggleConfirmationModal"
  />
</template>